import { render, staticRenderFns } from "./CustomerLoyal.vue?vue&type=template&id=75753a09&scoped=true&"
import script from "./CustomerLoyal.vue?vue&type=script&lang=js&"
export * from "./CustomerLoyal.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLoyal.vue?vue&type=style&index=0&id=75753a09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75753a09",
  null
  
)

export default component.exports